import React from 'react';
import { motion } from 'framer-motion';
import { TargetPrecisionIcon, AuthorityBadgeIcon, AutomationIcon } from './CustomIcons';
const phases = [{
  num: '01',
  title: 'FASE 1 — ATRACCIÓN QUIRÚRGICA',
  icon: TargetPrecisionIcon,
  body: <>
        No disparamos a ciegas. Usamos{' '}
        <strong className="text-white font-bold" data-id="element-327">
          IA y Rastreo de Intención de Compra
        </strong>{' '}
        para aparecer frente al propietario que acaba de buscar 'Roofing repair'
        o 'New roof cost' en tu código postal. Gente con el dinero en la mano y
        la urgencia en la puerta.
      </>
}, {
  num: '02',
  title: 'FASE 2 — CONVERSIÓN DE AUTORIDAD',
  icon: AuthorityBadgeIcon,
  body: <>
        Tu competencia tiene una web que parece de 2010. Nosotros te construimos
        un <strong className="text-white font-bold" data-id="element-328">Blindaje Digital</strong>:
        Una Landing Page que en 5 segundos le grita al cliente que eres la única
        opción segura. Generamos confianza antes de que digas 'Hola'.
      </>
}, {
  num: '03',
  title: 'FASE 3 — ESCALA & CITA AUTOMÁTICA',
  icon: AutomationIcon,
  body: <>
        ¿Estás en el techo y no puedes contestar? Nuestra IA recibe el lead, le
        responde por WhatsApp, le pide fotos del daño y agenda el estimado en tu
        calendario.{' '}
        <strong className="text-white font-bold" data-id="element-329">
          Tú solo subes a cerrar el contrato.
        </strong>
      </>
}];
export function SystemSection() {
  return <section className="py-16 md:py-24 px-4 bg-carbon relative" data-id="element-330">
      <div className="max-w-4xl mx-auto" data-id="element-331">
        <div className="text-center mb-12 md:mb-16" data-id="element-332">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-block bg-gold/10 text-gold text-xs font-bold tracking-widest px-4 py-1.5 rounded-full mb-6" data-id="element-333">
            SISTEMA A.C.E.™ ROOFING
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-2xl md:text-4xl font-heading font-bold text-gold leading-tight" data-id="element-334">
            No es marketing. Es Ingeniería de Adquisición.
          </motion.h2>
        </div>

        <div className="relative" data-id="element-335">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute left-[2.25rem] top-8 bottom-8 w-[1px] bg-gradient-to-b from-gold/50 via-gold/20 to-transparent z-0" data-id="element-336"></div>

          <div className="space-y-8 md:space-y-12" data-id="element-337">
            {phases.map((phase, index) => {
            const Icon = phase.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-50px'
            }} transition={{
              duration: 0.6,
              delay: index * 0.2
            }} className="relative z-10 flex flex-col md:flex-row gap-4 md:gap-8 items-start" data-id="element-338">
                  <div className="flex items-center gap-4 md:block shrink-0" data-id="element-339">
                    <div className="bg-carbon border border-gold/30 rounded-full w-12 h-12 md:w-16 md:h-16 flex items-center justify-center shadow-[0_0_15px_rgba(242,183,5,0.1)]" data-id="element-340">
                      <span className="font-heading font-bold text-gold text-lg md:text-xl" data-id="element-341">
                        {phase.num}
                      </span>
                    </div>
                    <div className="md:hidden bg-emerald/10 p-2 rounded-full" data-id="element-342">
                      <Icon className="w-5 h-5 text-emerald" data-id="element-343" />
                    </div>
                  </div>

                  <div className="bg-[#0A0A0A] border border-[#151515] rounded-xl p-5 md:p-6 flex-1 shadow-sm" data-id="element-344">
                    <div className="flex items-center gap-3 mb-3" data-id="element-345">
                      <div className="hidden md:block bg-emerald/10 p-2 rounded-full" data-id="element-346">
                        <Icon className="w-5 h-5 text-emerald" data-id="element-347" />
                      </div>
                      <h3 className="text-lg md:text-xl font-bold text-white tracking-wide" data-id="element-348">
                        {phase.title}
                      </h3>
                    </div>
                    <p className="text-sm md:text-base text-gray-sec leading-relaxed" data-id="element-349">
                      {phase.body}
                    </p>
                  </div>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}